import React, {Component} from 'react'
import {Grid, Typography, withStyles} from '@material-ui/core'
import style from './style'

class PaymentSummary extends Component {

    render() {
        let expiration_date_pyme_nacion
        const {
            classes,
            amount,
            currency,
            installments,
            first_installment_expiration_date
        } = this.props

        if (first_installment_expiration_date)
            expiration_date_pyme_nacion = <div>Pago de la 1° cuota el {first_installment_expiration_date}</div>

        return (
            <React.Fragment>
                <Grid container alignItems={"center"}>
                    <Grid item xs={3}>
                        <Typography variant="h4" className={classes.leftText}>A pagar</Typography>
                    </Grid>

                    <Grid item xs={9}>
                        <Grid container justify={"flex-end"}>
                            <Grid item className={classes.autoWidth}>
                                <Typography variant="h4"
                                            className={classes.priceText}
                                            id="amount">{currency} {amount}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container justify={"flex-end"}>
                            <Grid item className={classes.autoWidth}>
                                <Typography variant="body1"
                                            className={classes.installmentText}>
                                    {installments && <span id="installments">en {installments} cuota{installments > 1 ? "s" : ""}</span>}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container justify={"flex-end"}>
                            <Grid item className={classes.autoWidth}>
                                <Typography variant="body1"
                                            className={classes.installmentText}>
                                    {expiration_date_pyme_nacion}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </React.Fragment>
        )
    }

}

export default withStyles(style)(PaymentSummary)
